import Popover from "@material-ui/core/Popover";
import React, { useState } from "react";
import { createCalculatedColumn, createComponentColumn } from "../../utils/ColumnUtils";
import { formatDate } from "../../utils/DateUtils";
import EAButton from "../EAButton";
import EATable from "../EATable";
import EATableActionButton from "../tableComponents/EATableActionButton";
import HistoryIcon from "@material-ui/icons/History";
import UpdateIcon from "@material-ui/icons/Update";

function EAHistorySelector({ additionalColumns, data, loading, onClickSelect, onCancel }) {
    const [anchorEl, setAnchorEl] = useState(null);
    const [selectedIndex, setSelectedIndex] = useState(null);
    const openHistory = Boolean(anchorEl);
    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const buildHistoryTable = () => {
        return (
            <EATable
                id={"tblHistory"}
                order={"desc"}
                columns={[
                    createComponentColumn(
                        "actions",
                        (row, index) => {
                            return (
                                <EATableActionButton id={"selectHistorie-" + index} iconName="ico-view">
                                    <span
                                        onClick={() => {
                                            handleClose();
                                            setSelectedIndex(index);
                                            onClickSelect(row);
                                        }}
                                        className={"w-100"}
                                        style={{
                                            height: "100%",
                                            display: "block",
                                        }}
                                    />
                                </EATableActionButton>
                            );
                        },
                        "",
                        null,
                        { width: "50px", minWidth: "50px", padding: "0", paddingLeft: "5px" }
                    ),
                    createCalculatedColumn(
                        "gueltigAb",
                        (row) => {
                            return row.auditInfo.gueltigAb ? formatDate(row.auditInfo.gueltigAb) : "";
                        },
                        "Gültig ab",
                        { padding: "2px" }
                    ),
                    createCalculatedColumn(
                        "gueltigBis",
                        (row) => {
                            return row.auditInfo.gueltigBis ? formatDate(row.auditInfo.gueltigBis) : "";
                        },
                        "Gültig bis",
                        { padding: "2px" }
                    ),
                    createCalculatedColumn(
                        "aenderungsgrund",
                        (row) => {
                            return row.auditInfo.aenderungsgrund ? row.auditInfo.aenderungsgrund : "";
                        },
                        "Bemerkung",
                        { padding: "2px" }
                    ),
                    createCalculatedColumn(
                        "timestamp",
                        (row) => {
                            if (row.statuswechsel) {
                                return formatDate(row.statuswechsel);
                            }
                            return row.auditInfo.geaendertAm ? formatDate(row.auditInfo.geaendertAm) : "";
                        },
                        "Geändert am",
                        { padding: "2px" }
                    ),
                    createCalculatedColumn(
                        "geaendertVon",
                        (row) => {
                            return row.auditInfo.geaendertVon ? row.auditInfo.geaendertVon : "";
                        },
                        "Geändert Von",
                        { padding: "2px" }
                    ),
                ].concat(additionalColumns ? additionalColumns : [])}
                data={data}
            />
        );
    };

    return (
        <React.Fragment>
            <div className={"ea-bb-left"}>
                <EAButton
                    onClick={handleClick}
                    id={"btnHistory"}
                    label={"Historie"}
                    loading={loading}
                    disabled={loading}
                    startIcon={<HistoryIcon style={{ color: "var(--primary-dark)" }} />}
                />
                {selectedIndex !== null && (
                    <EAButton
                        onClick={() => {
                            onCancel();
                            setSelectedIndex(null);
                        }}
                        id={"btnHistoryCancel"}
                        label={"zurück zum aktuellen Datensatz"}
                        startIcon={<UpdateIcon />}
                        variant={"text"}
                        style={{ paddingLeft: "var(--horizontal-spacing)" }}
                    />
                )}
            </div>
            <Popover
                open={openHistory}
                anchorEl={anchorEl}
                onClose={handleClose}
                anchorOrigin={{
                    vertical: "top",
                    horizontal: "left",
                }}
                transformOrigin={{
                    vertical: "bottom",
                    horizontal: "left",
                }}
            >
                {buildHistoryTable()}
            </Popover>
        </React.Fragment>
    );
}

export default EAHistorySelector;
